export const SESSION_KEY = "session";
export const TV_TOKENS_KEY = "tvTokens";
export const USERS_KEY = "users";
export const USER_ID_KEY = "userId";
export const CURRENT_SUB_PROFILE_ID_KEY = "currentSubprofileId";
export const DEVICE_KEY = "device";
export const VOLUME_KEY = "playerVolume";
export const PROFILES_KEY = "profiles";
export const PRODUCTS_KEY = "nf_products";
export const DUNNING_DIALOG_DISMISSED = "nf_dunningDialogDismissed";
export const SUBTITLE_SETTINGS = "subtitles";
